module.exports = __webpack_public_path__ + "img/00014.aa31f3f8.webp";